<div class="ps-strip-wrapper">
  <div class="ps-strip">
    <div class="ps-stat">
      <div class="ps-stat-num" aria-hidden="true">{{ profilePercent }}%</div>
      <div class="ps-stat-label" aria-hidden="true">Profile complete</div>
      <mat-progress-bar
        class="ps-progress"
        mode="determinate"
        [value]="profilePercent"
        [attr.aria-valuenow]="profilePercent"
        aria-valuemin="0"
        aria-valuemax="100"
        [attr.aria-label]="'Profile ' + profilePercent + '% complete'"
      >
      </mat-progress-bar>
    </div>

    <div class="ps-divider" aria-hidden="true"></div>

    <div class="ps-stat" aria-label="3 upcoming deadlines">
      <div class="ps-stat-num" aria-hidden="true">3</div>
      <div class="ps-stat-label" aria-hidden="true">Upcoming deadlines</div>
    </div>

    <div class="ps-divider" aria-hidden="true"></div>

    <div class="ps-stat" aria-label="0 new messages">
      <div class="ps-stat-num" aria-hidden="true">0</div>
      <div class="ps-stat-label" aria-hidden="true">New messages</div>
    </div>

    <div class="ps-divider" aria-hidden="true"></div>

    <div class="ps-actions">
      <a
        mat-stroked-button
        routerLink="/profile"
        class="ps-action-btn"
        aria-label="Edit your profile"
        >Edit profile</a
      >
    </div>
  </div>
</div>
